import SeoArticlePage from '@/pages/article/SeoArticlePage';
import { bestFindsArticle } from '@/mocks/articles';

export default function BestFindsPage() {
  return <SeoArticlePage article={bestFindsArticle} />;
}